import { useAtomValue } from "jotai";
import { modulesAtom } from "../../../../atoms/GlobalAtoms";
import { SelectPicker } from "rsuite";

interface Props {
  fieldValues: any;
  setFieldValues: React.Dispatch<React.SetStateAction<any>>;
}

export default function FieldTypeFilter({
  fieldValues,
  setFieldValues,
}: Props) {
  const modules = useAtomValue(modulesAtom);

  return (
    <>
      <h4 className="mb-0">Data Source</h4>
      <div className="small mb-2">
        The data source you want to create filters for.
      </div>
      <SelectPicker
        block
        placeholder="Select Data Source"
        data={modules || []}
        value={fieldValues?.source}
        valueKey="APIName"
        labelKey="Name"
        onChange={(val) => setFieldValues({ ...fieldValues, source: val })}
      />
    </>
  );
}
